export interface EachAssigneesRes {
  id: number;
  imageUrl: string;
  address: string;
  name: string;
  email?: string;
}

// TODO: combine EachAssigneesOriginalRes and EachAssigneesRes
export interface EachAssigneesOriginalRes {
  id: number;
  imageUrl: string;
  email: string;
  name: string;
}

export declare type AssigneesResI = EachAssigneesRes[];

class Assignee {
  imageUrl: string;
  id: number;
  name: string;
  address: string;
  constructor(assignee: EachAssigneesRes) {
    this.imageUrl = assignee?.imageUrl;
    this.id = assignee?.id;
    this.name = assignee?.name;
    this.address = assignee?.address;
  }
  firstLetter() {
    return (this.name || this.address || '')[0] || '?';
  }
  displayName(emptyString = '-') {
    return this.name || this.address || emptyString;
  }
  hasAssignee() {
    return this.id !== undefined;
  }
}

export { Assignee };
